import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import Parts from "@/pages/Parts";
import Industries from "@/pages/Industries";
import Construction from "@/pages/Construction";
import Uptime from "@/pages/Uptime";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Quote from "@/pages/Quote";
import RequestPart from "@/pages/RequestPart";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      let tries = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (tries++ < 30) setTimeout(tryScroll, 100);
      };
      setTimeout(tryScroll, 100);
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function SiteRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/parts" element={<Layout><Parts /></Layout>} />
      <Route path="/industries" element={<Layout><Industries /></Layout>} />
      <Route path="/construction" element={<Layout><Construction /></Layout>} />
      <Route path="/uptime" element={<Layout><Uptime /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/quote" element={<Layout><Quote /></Layout>} />
      <Route path="/request-part" element={<Layout><RequestPart /></Layout>} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollManager />
        <SiteRoutes />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#181918", border: "1px solid #343530", borderRadius: 0, color: "#F2F0EA", fontFamily: "IBM Plex Mono, monospace" } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
